<template>
  <el-row class="articleContent" ref="print" id="print">
    <el-col :span="24">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item
          ><span style="cursor: pointer;" @click="runExtend">{{
            articleInfo.extendFeild3
          }}</span></el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ articleInfo.articleTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="printButton" style="margin-bottom: 10px">
        <div
          class="flex"
          v-show="
            this.$route.query.type == 1
              ? true
              : false || this.$route.query.type == 2
              ? false
              : true || this.$route.query.type == 3
              ? false
              : true
          "
        >
          <el-button @click="last()" v-show="lastid == null ? false : true"
            >&lt; 上一篇</el-button
          >
          <el-button
            style="margin-left: 20px"
            @click="next()"
            v-show="nextid == null ? false : true"
            >下一篇 &gt;</el-button
          >
        </div>
        <el-button class="themeButton" @click="pri" icon="el-icon-printer"
          >打印本页</el-button
        >
      </div>
      <div
        class="borderCo"
        v-show="
          this.$route.query.type == 3
            ? true
            : false || this.$route.query.type == 1
            ? false
            : true || this.$route.query.type == 2
            ? false
            : true
        "
      >
        <el-row>
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              索引号
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              ：{{ upList.infoIndex }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              信息分类
            </div></el-col
          >
          <!-- themeTypeNames -->
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              ：{{ zdlist }}
            </div></el-col
          >
          <!--        </el-row>-->
          <!--        <el-row>-->
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发文机构
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              ：{{ upList.postOffice }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              成文日期
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              ：{{ upList.writtenDate | formatDate }}
            </div></el-col
          >
          <!--        </el-row>-->
          <!--        <el-row>-->
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发文字号
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light" style="overflow: hidden">
              ：{{ upList.infoNum }}
            </div></el-col
          >
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              发布日期
            </div></el-col
          >
          <el-col :span="8"
            ><div class="grid-content bg-purple-light">
              ：{{ upList.publishDate | formatDate }}
            </div></el-col
          >
          <!--        </el-row>-->
          <!--        <el-row>-->
          <el-col :span="4"
            ><div class="grid-content bg-purple" style="text-align: right">
              标题
            </div></el-col
          >
          <el-col :span="20"
            ><div class="grid-content bg-purple-light">
              ：{{ upList.infoTitle }}
            </div></el-col
          >
        </el-row>
      </div>
      <div class="printContent">
        <p class="readCountLabel">
          浏览次数：<span class="readCount">{{
            articleInfo.readCount ? articleInfo.readCount : 0
          }}</span>
        </p>
        <p :style="'color:' + titleColor" class="contentHeader">
          {{ articleInfo.articleTitle }}
        </p>
        <div class="con1">
          <div v-if="sizeFlag">
            <p
              style="
                margin-top: 15.1pt;
                margin-bottom: 0pt;
                line-height: 5pt;
                text-align: center;
              "
            >
              <span style="font-family: Microsoft YaHei; font-size: 16pt">{{
                upList.infoNum
              }}</span>
            </p>
          </div>
          <div class="content" id="content"></div>
        </div>
      </div>
      <div class="printButton" style="margin: 0">
        <el-button class="themeButton" @click="pri" icon="el-icon-printer"
          >打印本页</el-button
        >
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { URL_PORTAL_INDEX, URL_PORTAL_FIND } from "../../../utils/api";
import util from "../../../utils/util";
import { frontHeater } from "../../../utils/md5encryption";
export default {
  name: "ArticleContent",
  data() {
    return {
      articleInfo: {
        // 标题
        articleTitle: "",
        extendFeild3: "办件结果公开", //栏目名称
        // 浏览次数
        readCount: 0,
      },
      //上侧表的数据
      upList: [],
      zdlist: "",
      lastid: "",
      nextid: "",
      sizeFlag: false,
      titleColor: "",
      feild3Flag: true,
    };
  },
  mounted() {
    this.getList(this.$route.query.id);
    this.getLastNextList(this.$route.query.id);
    if (this.$route.query.type == 1 || this.$route.query.type == 2) {
      this.feild3Flag = false;
      this.articleInfo.extendFeild3 = "监管执法情况公示";
    }
  },
  filters: {
    formatDate: function (value) {
      if (value != undefined) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        return y + "年" + MM + "月" + d + "日";
      }
    },
  },
  methods: {
    pri() {
      this.$print(this.$refs.print);
    },
    // 获取数据列表
    getList(val) {
      let result = frontHeater(["id"], [val]);
      let Url = util.getAjaxUrl("axiosThree");
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = val;
      this.$http.get(Url + `${URL_PORTAL_FIND}/${val}`).then((res) => {
        if (res.status == 200) {
          this.upList = res.data;
          this.articleInfo.articleTitle = res.data.infoTitle;
          this.titleColor = res.data.fontColor;
          this.zdlist = res.data.themeTypeNames[0];
          this.articleInfo.readCount = res.data.readNumber;
          let list = document.getElementById("content");
          let contents = res.data.infoContent;
          let typeSize = contents.charAt(28);
          console.log(res.data.infoContent.charAt(28));
          if (typeSize === "0") {
            this.sizeFlag = true;
          } else {
            this.sizeFlag = false;
          }
          list.innerHTML = contents;
        }
      });
    },
    //链接跳转
    runExtend() {
      if (this.feild3Flag) {
        this.$router.push({ name: "handle_result" });
      }else{
        this.$router.push({ name: "enforce-notice" });
      }
    },
    // 获取上一篇下一篇的数据
    getLastNextList(val) {
      let result = frontHeater(["id"], [val]);
      let Url = util.getAjaxUrl("axiosThree");
      let params = {
        id: val,
        superviseType: "双随机一公开",
      };
      this.$http.defaults.headers.common["secretTime"] = result.timeStamp;
      this.$http.defaults.headers.common["secretSign"] =
        result.encryptionString;
      this.$http.defaults.headers.common["secretDefinite"] =
        result.parameterKey;
      this.$http.defaults.headers.common["appCode"] = result.secret;
      this.$http.defaults.headers.common["id"] = val;
      this.$http.post(Url + URL_PORTAL_INDEX, params).then((res) => {
        if (res.status == 200) {
          this.lastid = res.data.lastId;
          this.nextid = res.data.nextId;
        }
      });
    },
    last() {
      this.getList(this.lastid);
      this.getLastNextList(this.lastid);
      this.lastid = "";
      this.nextid = "";
    },
    next() {
      this.getList(this.nextid);
      this.getLastNextList(this.nextid);

      this.lastid = "";
      this.nextid = "";
    },
  },
};
</script>

<style scoped lang="less">
@import "../../../styles/theme";

.articleContent {
  /*width: 96%;*/
  width: 100%;
  margin: 0 auto;
  /*padding-top: 10px;*/
  padding: 20px;
  .printButton {
    width: 100%;
    display: flow-root;
    margin: 20px 0;
  }
  .themeButton {
    background-color: @theme-color;
    border-color: @theme-color;
    color: #ffffff;
    padding: 9px 15px;
    float: right;
    font-size: 12px;
    vertical-align: top;
  }
  .themeButton:hover {
    background-color: #c54949;
  }
  .readCountLabel {
    text-align: right;
    padding-right: 10px;
    margin: 10px 0 15px;
    font-size: 16px;
  }
  .readCount {
    color: #ec1d1d;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .contentHeader {
    color: #ec1d1d;
    border-bottom: 1px solid #ec1d1d;
    font-size: 22px;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    text-align: center;
    line-height: 38px;
    font-weight: 700;
    padding: 6px 0;
  }
  .con1 {
    width: 100%;
    .content {
      /*width: 90%;*/
      /*margin: 20px auto;*/
      margin: 20px 0 10px;
      font-size: 17px !important;
      line-height: 1.15;
      border-bottom: 1px solid #303133;
    }
  }
  .flex {
    display: inline-block;
    width: 90%;
    // margin: 0 auto;
    // margin-left: 5%;
    // padding-right: 5%;
    text-align: center;
    .el-button {
      width: 88px;
      height: 32px;
      line-height: 5px;
      text-align: center;
      padding: 0;
    }
    .el-button:hover {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
    .el-button:active {
      color: #7c2121;
      border-color: #7c2121;
    }
    .el-button:focus {
      color: #7c2121;
      border-color: #b71c1c;
      background-color: #f8e8e8;
    }
  }
  .borderCo {
    padding: 10px;
    border: 1px solid #beac88;
    font-size: 14px;
    line-height: 2;
    color: #303133;
  }
}
/deep/ .el-col {
  margin: 4px 0;
}
</style>
